import React, {useState, useEffect} from 'react';
import {withRouter} from 'react-router-dom';
import {compose} from 'recompose';
import PropTypes from 'prop-types';
import {Table, TableBody, TablePagination} from "@material-ui/core";

import TableRows from './TableRows';
import t from "../../../languages/pl";
import CarDetailsHeader from './CarDetailsHeader';
import withFilters from './../../HOC/withFilters';
import {sortDescending, sortAscending} from '../../../utils/staticData';
import {sortByKey, useQuery, countHeightWhen2HeightToolbarUsed, sortByRegistration} from '../../../utils/helpers';
import TableContainerWithHeight from "../../Common/TableContainerWithHeight";
import {useWindowSize} from '../../../utils/hooks/useWindowResize';

import {carsOrderEnum} from '../../../utils/enums/carsTableOrderEnum.js';

const CarsTable = (props) => {
    const {cars, onSelectedRegistrationNo, onFilter} = props;
    const query = useQuery();
    const urlParams = query.get("ids");
    const [filteredElements, setFilteredElements] = useState(cars);
    const [quantity, setQuantity] = useState(20);
    const [page, setPage] = useState(0);
    const [order, setOrder] = useState(sortDescending);
    const [meterReadingOrder, setMeterReadingOrder] = useState(sortDescending);
    const [registrationNoOrder, setRegistrationNoOrder] = useState(sortDescending);
    const [carsListLength, setCarsListLength] = useState(0);
    const [activeSort, setActiveSort] = useState(carsOrderEnum.ecoOrder);
    const {height} = useWindowSize();

    useEffect(() => {
        setCarsListLength(cars.length);
    }, [cars]);

    useEffect(() => {
        if (activeSort === carsOrderEnum.meterReadingOrder) {
            let carsToDisplay = getRegistrationFromUrl(urlParams, cars);
            let sorted = sortByKey(carsToDisplay.length > 0 ? carsToDisplay : cars, meterReadingOrder, "dystans");
            let filtered = sorted.slice(page * quantity, page * quantity + quantity);

            setFilteredElements(filtered);

            if (carsToDisplay.length > 0) {
                setCarsListLength(carsToDisplay.length);
            } else {
                setCarsListLength(cars.length);
            }

            onFilter(sorted);
        }
    }, [cars, page, quantity, meterReadingOrder]);

    useEffect(() => {
        if (activeSort === carsOrderEnum.ecoOrder) {
            let carsToDisplay = getRegistrationFromUrl(urlParams, cars);
            let sorted = sortByKey(carsToDisplay.length > 0 ? carsToDisplay : cars, order, "eco");
            let filtered = sorted.slice(page * quantity, page * quantity + quantity);

            setFilteredElements(filtered);

            if (carsToDisplay.length > 0) {
                setCarsListLength(carsToDisplay.length);
            } else {
                setCarsListLength(cars.length);
            }

            onFilter(sorted);
        }
    }, [cars, page, quantity, order]);

    useEffect(() => {
        if (activeSort === carsOrderEnum.registrationNoOrder) {
            let carsToDisplay = getRegistrationFromUrl(urlParams, cars);
            let sorted = sortByRegistration(carsToDisplay.length > 0 ? carsToDisplay : cars, registrationNoOrder, "rejestracja");
            let filtered = sorted.slice(page * quantity, page * quantity + quantity);

            setFilteredElements(filtered);

            if (carsToDisplay.length > 0) {
                setCarsListLength(carsToDisplay.length);
            } else {
                setCarsListLength(cars.length);
            }

            onFilter(sorted);
        }
    }, [cars, page, quantity, registrationNoOrder]);

    const getRegistrationFromUrl = (query, data) => {
        if (!query) {
            return [];
        }

        let ids = query.split(";");

        if (ids.length === 1) {
            onSelectedRegistrationNo(ids[0]);
        } else {
            setCarsListLength(ids.length);
        }

        return data.filter(car => {
            let foundCar = ids.find(param => car.rejestracja === param);

            if (foundCar) {
                return car;
            }
        });
    };

    const handleChangeRowPerPage = e => {
        setPage(Math.floor(page * (quantity / e.target.value)));
        setQuantity(e.target.value);
    };

    const handlePageChange = (obj, number) => {
        setPage(number);
    };

    const handleSortOrderChange = () => {
        setActiveSort(carsOrderEnum.ecoOrder);

        if (order === sortAscending) {
            setOrder(sortDescending);
        } else {
            setOrder(sortAscending);
        }
    };

    const handleSortMeterReadingOrderChange = () => {
        setActiveSort(carsOrderEnum.meterReadingOrder);
        if (meterReadingOrder === sortAscending) {
            setMeterReadingOrder(sortDescending);
        } else {
            setMeterReadingOrder(sortAscending);
        }
    };

    const handleSortRegistrationNoOrderChange = () => {
        setActiveSort(carsOrderEnum.registrationNoOrder);
        if (registrationNoOrder === sortAscending) {
            setRegistrationNoOrder(sortDescending);
        } else {
            setRegistrationNoOrder(sortAscending);
        }
    };

    const handleDisplayedRows = (from, to, count) => {
        return `${from}-${to} z ${count}`;
    };

    return (
        <React.Fragment>
            <TableContainerWithHeight height={countHeightWhen2HeightToolbarUsed(height ? height - 60 : null)}>
                <Table stickyHeader>
                    <CarDetailsHeader
                        activeSort={activeSort}
                        order={order}
                        onSortOrderChange={handleSortOrderChange}
                        meterReadingOrder={meterReadingOrder}
                        onSortMeterReadingOrderChange={handleSortMeterReadingOrderChange}
                        registrationNoOrder={registrationNoOrder}
                        onSortRegistrationNoOrderChange={handleSortRegistrationNoOrderChange}
                    />
                    <TableBody>
                        <TableRows cars={filteredElements}/>
                    </TableBody>
                </Table>
            </TableContainerWithHeight>
            <TablePagination
                rowsPerPageOptions={[10, 20, 30]}
                component="div"
                labelRowsPerPage={t.quantityOfDisplayingElements}
                nextIconButtonText={t.nextPage}
                backIconButtonText={t.previousPage}
                count={carsListLength}
                rowsPerPage={quantity}
                page={page}
                onChangePage={handlePageChange}
                onChangeRowsPerPage={handleChangeRowPerPage}
                labelDisplayedRows={({from, to, count}) => handleDisplayedRows(from, to, count)}
            />
        </React.Fragment>
    );
};

CarsTable.propTypes = {
    onSelectedRegistrationNo: PropTypes.func,
    showArchived: PropTypes.bool,
    showNotArchived: PropTypes.bool,
    onFilter: PropTypes.func,
    cars: PropTypes.array,
};

export default compose(
    withFilters,
    withRouter,
)(CarsTable);
